import { CSSObject } from "@emotion/react";
import { typographyStyles } from "@newsela/angelou";

const { fontFamily } = typographyStyles;

export const directionsLabel: CSSObject = {
  display: "block",
  fontWeight: "bold",
  marginTop: "10px",
  ...fontFamily.circular,
};

export const directionsTextareaWrapper: CSSObject = {
  margin: "0 0 10px",
};

export const directionsTextarea: CSSObject = {
  width: "100%",
  display: "inline-block",
  fontFamily: "inherit",
  fontSize: "0.75em",
  boxSizing: "border-box",
  padding: "5px",
  resize: "none",
  overflow: "hidden",
  minHeight: "54px",
};
